// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2W-Cp","footer":"ModalError_footer__12H7R"};